import React from 'react';
import SolicitarFacturacion from '../TabViews/Facturacion/SolicitarFacturacion';
import Facturation from '../TabViews/Facturacion/EditarFacturacion';
import AplicarColorUso from '../../modals/AplicarColorUso';
import AgregarEquiposAdicionales from '../TabViews/EquiposLogistica/AgregarEquiposAdicionales/index';
import DesasignarPedido from '../../modals/DesasignarPedido';
import ValidarAsignacion from '../../modals/ValidarAsignacion';
import AgregarBonos from '../TabViews/Bonos/AgregarBonos';
import CorreoPedidos from "../../modals/CorreoPedidos";
import BuscarCliente from '../../modals/BuscarCliente';


function showModal(modalName, that) {

    console.log('modalName', modalName)

    switch (modalName) {
        case 'AplicarColorUso':
            return (
                <AplicarColorUso
                    closeModal={that.closeModal}
                    idFichaVenta={that.props.fdvID}
                    loading={that.props.loading}
                    openAlert={that.props.openAlert}
                    pedidos={that.state.pedidosConCheck}
                    pedidosColorUsoVieneDe={that.state.pedidosColorUsoVieneDe}
                    pedidosColorUsoIdUso={that.state.pedidosColorUsoIdUso}
                    pedidosColorUsoTieneColorUsoDistintos={that.state.pedidosColorUsoTieneColorUsoDistintos}
                    pedidosColorUsoColores={that.state.pedidosColorUsoColores}
                    codAreaVta={that.props.proforma.codAreaVta}
                    codFamiliaVeh={that.props.proforma.codFamiliaVeh}
                    codMarca={that.props.proforma.codMarca}
                    nurPedidos={that.props.nurPedidos}
                    ordersColorsList={that.state.ordersColorsList}
                    pedidosConCheck={that.state.pedidosConCheck}
                    allUseOrdersFV={that.state.allUseOrdersFV}
                    proforma={that.props.proforma}
                    loading={that.props.loading}
                    traerColorUso={that.traerColorUso}
                    activeFilterPedido={that.props.activeFilterPedido}
                    changeIndex={that.clearVariablechangeIndex}
                    selectAll={that.selectAll}

                />
            );
        case 'SolicitarFacturacion':

            if (that.state.pedidosClienteFacturacion.length === 0) return null;
            return (
                <SolicitarFacturacion
                    closeModal={that.closeModal}
                    idFichaVenta={that.props.fdvID}
                    pedidos={that.state.pedidosClienteFacturacion}
                    loading={that.props.loading}
                    openAlert={that.props.openAlert}
                    llamadaProformaOrTabProforma={0}
                    whereRunTabOrProf={'0'}
                    listProformaOrTabProforma={that.state.pedidosConCheck}
                />
            );
        case 'AgregarEquiposAdicionales':
            return (

                <AgregarEquiposAdicionales
                    closeModal={that.closeModal}
                    proforma={that.props.proforma}
                    pedidosConCheck={that.state.pedidosConCheck}
                    fdv={that.props.fdv}
                    loading={that.props.loading}
                    openAlert={that.props.openAlert}
                    tipoLlamadaEquiposAdicionales={'0'}
                />

            );
        case 'DesasignarPedido':
            return (
                <DesasignarPedido
                    closeModal={that.closeModal}
                    pedidosEquiposAdicionales={that.state.pedidosConCheck}
                    nurPedidos={that.props.nurPedidos}
                    proforma={that.props.proforma}
                    fdv={that.props.fdv}
                    openAlert={that.props.openAlert}
                    loading={that.props.loading}
                    loadProformas={that.props.loadProformas}
                    fnLimpiarPedidosConCheck={that.fnLimpiarPedidosConCheck}
                    traerFacturacion={that.props.traerFacturacion}
                    fnVaciarPedidosConCheck={that.props.fnVaciarPedidosConCheck}
                    fnUnSelectedAll={that.fnUnSelectedAll}
                    changeIndex={that.props.changeIndex}
                    pedidosXfichaVenta={that.props.pedidosXfichaVenta}
                />
            );
        case 'AgregarBonos':
            console.log('erro', that.props.proformaSeleccionada)
            return (
                <AgregarBonos
                    closeModal={that.closeModal}
                    pedidos={that.props.pedidosXfichaVentaBonos}
                    addPedidosAsignarBonos={that.addPedidosAsignarBonos}
                    arrayAsignarBonos={that.state.pedidosConCheck}
                    fdvID={that.props.fdvID}
                    profroma={that.props.proformaSeleccionada}
                    registrarBonos={that.registrarBonos}
                    flagBonos={that.state.flagBonos}
                    changeFlagBonos={that.changeFlagBonos}
                    renderLoad={that.renderLoad}
                    isOpen={true}
                    codMonedaBono={that.state.codMonedaBono}
                    montoBonoProforma={that.state.montoBonoProforma}
                    flagActionTab={that.state.flagActionTab}
                    fnUnSelectedAll={that.fnUnSelectedAll}
                    openAlert={that.props.openAlert}
                    pedidosToEdit={that.state.pedidosConCheck}
                    pedidosToEditCodFiv={that.state.listaPedidosXCortesia}
                    listaPedidosXProforma={that.state.listaPedidosXProforma}
                    listaBonosXproforma={that.state.listaBonoXCortesia}
                    listaBonosXproformaEstados={that.state.listaBonosXproforma.filter(entry => entry.codEstaVale === 'R' || entry.codEstaVale === 'I').map(entry => {
                        return entry.codFiveBono
                    })}

                />
            );
        case 'ValidarAsignacion':
            return (
                <ValidarAsignacion
                    closeModal={that.closeModal}
                    arrayAsignarBonos={that.state.selectPedidosPreasignados}
                    pedidos={that.props.pedidosXfichaVentaBonos}
                    fdvID={that.props.fdvID}
                    fdv={that.props.fdv}
                    profroma={that.props.proformaSeleccionada}
                    validarAsignacion={that.props.validarAsignacion}
                    loadProformas={that.props.loadProformas}
                    loading={that.props.loading}
                    loadPage={that.props.loadPage}
                    clearCheck={that.clearCheck}
                    fnUnSelectedAll={that.fnUnSelectedAll}
                    openAlert={that.props.openAlert}
                    pedidosXfichaVenta={that.props.pedidosXfichaVenta}
                    fnChangeIndInitialize={that.props.fnChangeIndInitialize}
                    changeIndex={that.clearVariablechangeIndex}
                    activeFilterPedido={that.props.activeFilterPedido}
                    selectAll={that.selectAll}
                    doneAsignacionDefinitiva={that.props.doneAsignacionDefinitiva}
                    ordersColorsList={that.state.ordersColorsList}
                    traerColorUso={that.traerColorUso}
                />
            );
        case 'EditaDatosSolicitarFacturacion':
            return (
                <Facturation
                    closeModal={that.closeModal}
                    fdvID={that.props.fdvID}
                    loading={that.props.loading}
                    pedidosConCheck={that.state.pedidosConCheck}
                    changeIndex={that.props.changeIndex}
                />
            );
        case 'CorreoPedidos':
            return (
                <CorreoPedidos
                    closeModal={that.closeModal}
                    fdvID={that.props.fdvID}
                    loading={that.props.loading}
                    pedidosConCheck={that.state.pedidosConCheck}
                    changeIndex={that.props.changeIndex}
                    /*Inicio Req 92528 ebarboza 30 08 2021 */
                    listaCorreos = {that.props.listaCorreos}
                    /*Fin Req 92528 ebarboza 30 08 2021 */
                />
            );
        /*REQ-86298*/
        case 'buscarCliente':
            return (
                <BuscarCliente
                    closeModal={that.closeModal}/>
            );
        default:
            return null;
    }
}

export default showModal;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/ContenidoTablas/showModals.js